module.exports = __webpack_public_path__ + "img/6.9e3580dd.jpg";